module.exports = __webpack_public_path__ + "blackaromaoil.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/blackaromaoil.png
// module id = 849
// module chunks = 0